/**
 *
 * Organizations/Dashboard/RegistrationsChartWidget
 *
 */

import React, { useMemo } from 'react'

// NPM Libraries

// Components
import RegistrationsChart from 'components/Organizations/Show/Events/RegistrationsChart'

function RegistrationsChartWidget({ data, users = [], user_ids = [] }) {
	const users_for_graph = useMemo(() => {
		if (user_ids.length === 0) return []

		return user_ids.reduce((acc, current) => {
			let new_list = [...acc]

			const user = users.find((u) => u.id === current)

			if (!!user) {
				new_list = [...new_list, user]
			}

			return new_list
		}, [])
	}, [users, user_ids])

	return (
		<div className="card">
			<div className="card-body">
				<div className="text-center">Registrations By Date</div>
				<div style={{ height: '400px' }}>
					{data && (
						<React.Fragment>
							{data.length === 0 ? (
								<div className="d-flex align-items-center justify-content-center h-100">
									<div className="alert alert-info">No registrations for this time period.</div>
								</div>
							) : (
								<RegistrationsChart
									data={data}
									users={users_for_graph}
									order_by_user={users_for_graph.length > 0}
								/>
							)}
						</React.Fragment>
					)}
				</div>
			</div>
		</div>
	)
}

RegistrationsChartWidget.propTypes = {}

export default RegistrationsChartWidget
